import { Dispatch, SetStateAction } from 'react';
import Modal from '@/components/v2/common/Modal';
import ReebeloCarePanel from './RightSection/ReebeloCarePanel';
import { CartWarrantyT } from '@/lib/reebelocare/types';

const CheckoutModal = ({
  showModal,
  setShowModal,
  totalReebeloCarePrice,
  setReebeloCareChecked,
  reebeloCareChecked,
  warranties,
  onCheckoutClick,
  isCheckingOut,
  onShowWarrantyDetails,
}: {
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  totalReebeloCarePrice: number;
  setReebeloCareChecked: Dispatch<SetStateAction<boolean>>;
  reebeloCareChecked: boolean;
  warranties: CartWarrantyT;
  onCheckoutClick: (reebeloCareChecked: boolean) => void;
  isCheckingOut: boolean;
  onShowWarrantyDetails?: () => void;
}) => (
  <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
    <div className="h-full bg-[#F8F8F8] p-4 text-sm">
      <ReebeloCarePanel
        warranties={warranties}
        reebeloCareChecked={reebeloCareChecked}
        setReebeloCareChecked={setReebeloCareChecked}
        totalReebeloCarePrice={totalReebeloCarePrice}
        isMobile
        onCheckoutClick={onCheckoutClick}
        isCheckingOut={isCheckingOut}
        onShowWarrantyDetails={onShowWarrantyDetails}
      />
    </div>
  </Modal>
);

export default CheckoutModal;
